// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const { BANK_PHONE_NUMBER_CLIENTS_ONLY_2_WITH_BRACKETS } = require('constants/index');

class CardsCancelPayLaterError extends React.Component {
    render() {
        const { cardId, immCard } = this.props;
        const cardAlias = immCard.getIn(['alias', 'current']);
        const goBackButtonLabel = formatText('cardCancelPayLater-cardCancelPayLater_backToCardsLink', [
            cardAlias
        ]).toUpperCase();
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-offset-2 col-xs-8">
                            <WizardError
                                customClassName="cards-cancel-pay-later-error"
                                errorMessage={formatText('cardCancelPayLater-cardCancelPayLater_errorTitle')}
                                mainButton={mainButton}
                            >
                                <div className="cards-cancel-pay-later-error__container">
                                    <FormattedText value="cardCancelPayLater-cardCancelPayLater_errorContent" injectedStrings={[BANK_PHONE_NUMBER_CLIENTS_ONLY_2_WITH_BRACKETS]} />
                                </div>
                            </WizardError>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardsCancelPayLaterError.propTypes = {
    cardId: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired
};

module.exports = CardsCancelPayLaterError;